/* ==========================================================================
   THAKAR HOUSE PDP — behaviour for sections/main-product.liquid
   Relies on theme.js globals when present (addToCart, recoQuickAdd,
   tkFetchRecsPool, tkBuyableVariant, tkGetRating, tkShareUrl,
   tkComputeFoodSubtotal, tkWeightMap) and degrades to plain requests when not.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('hp');
  if (!root) return;

  function $(id) { return document.getElementById(id); }
  function $$(sel, el) { return [].slice.call((el || root).querySelectorAll(sel)); }
  function rs(paise) {
    var r = paise / 100;
    return '₹' + (r % 1 ? r.toFixed(2) : String(r)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SERVES = parseInt(root.getAttribute('data-serves'), 10) || 2;
  var THRESHOLD = parseInt(root.getAttribute('data-threshold'), 10) || 799;
  var HANDLE = root.getAttribute('data-handle');
  var TITLE = (document.querySelector('.hp-title') || {}).textContent || document.title;

  /* ---------- gallery ---------- */
  var track = $('hp-track');
  var slides = track ? $$('.hp-arch', track) : [];
  var dots = $('hp-dots') ? [].slice.call($('hp-dots').children) : [];
  var thumbs = $$('[data-hp-img]');
  var gcount = $('hp-gcount');
  function currentSlide() {
    if (!track || slides.length < 2) return 0;
    var w = slides[1].offsetLeft - slides[0].offsetLeft || 1;
    return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
  }
  var gal = track && track.closest('.hp-gal');
  var curSlide = 0;
  function markSlide(i) {
    curSlide = i;
    if (gal && slides[i]) gal.classList.toggle('is-photo', !slides[i].classList.contains('is-packslide'));
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
    if (gcount) gcount.textContent = (i + 1) + ' / ' + slides.length;
  }
  function goSlide(i) {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    markSlide(i);
  }
  // Which slides are pack shots? A pack shot on white has a plain, light, even edge all round;
  // a photograph or infographic does not (colour, text or pattern reaches the edge). Read each
  // picture's outer ring on a 32px copy once it has loaded: a pack is contained on stone and
  // blended in (is-pack); anything else is a photo, which fills the 4:5 frame when its own shape
  // is close to it (is-fill) and is shown whole otherwise. Every slide keeps the same frame, so
  // only the picture's fit changes. A picture the canvas may not read keeps the server's guess.
  function kindOf(img) {
    try {
      var n = 32, c = document.createElement('canvas');
      c.width = c.height = n;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data, ring = [], i, j, k;
      for (i = 0; i < n; i++) for (j = 0; j < n; j++) {
        if (i > 1 && i < n - 2 && j > 1 && j < n - 2) continue;
        k = (i * n + j) * 4;
        ring.push([d[k], d[k + 1], d[k + 2], d[k + 3]]);
      }
      var light = 0, even = 0, m = [0, 0, 0];
      ring.forEach(function (p) { m[0] += p[0]; m[1] += p[1]; m[2] += p[2]; });
      m = m.map(function (v) { return v / ring.length; });
      ring.forEach(function (p) {
        if (p[3] < 200 || (Math.min(p[0], p[1], p[2]) > 200 && Math.max(p[0], p[1], p[2]) - Math.min(p[0], p[1], p[2]) < 26)) light++;
        if (Math.abs(p[0] - m[0]) + Math.abs(p[1] - m[1]) + Math.abs(p[2] - m[2]) < 30) even++;
      });
      return light / ring.length > 0.95 && even / ring.length > 0.92 ? 'pack' : 'photo';
    } catch (e) { return null; }
  }
  function setKind(slide, kind) {
    var img = slide.querySelector('img'), i = slides.indexOf(slide);
    if (!img || !kind) return;
    var pack = kind === 'pack', r = img.naturalWidth / (img.naturalHeight || 1);
    slide.classList.toggle('is-packslide', pack);
    img.classList.toggle('is-pack', pack);
    img.classList.toggle('is-fill', !pack && r >= 0.7 && r <= 0.92);
    var th = thumbs[i] && thumbs[i].querySelector('img');
    if (th) th.classList.toggle('is-pack', pack);
    if (i === curSlide && gal) gal.classList.toggle('is-photo', !pack);
  }
  slides.forEach(function (slide) {
    var img = slide.querySelector('img');
    if (!img) return;
    var go = function () { if (img.naturalWidth) setKind(slide, kindOf(img)); };
    if (img.complete) go(); else img.addEventListener('load', go, { once: true });
  });
  if (track && slides.length > 1) {
    var gRaf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(gRaf);
      gRaf = requestAnimationFrame(function () { markSlide(currentSlide()); });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goSlide(+t.getAttribute('data-hp-img')); }); });
  }

  /* ---------- state ---------- */
  var packs = $$('.hp-pack');
  var vidInput = $('hp-vid');
  var qtyInput = $('hp-qty-input');
  var qty = 1;
  var sel = packs.filter(function (p) { return p.getAttribute('aria-checked') === 'true'; })[0] || null;
  var available = !($('hp-atc') && $('hp-atc').disabled);
  function selPrice() { return sel ? +sel.getAttribute('data-price') : (+root.getAttribute('data-price') || 0); }
  if (!sel) {
    var p0 = $('hp-price');
    root.setAttribute('data-price', p0 ? Math.round(parseFloat(p0.textContent.replace(/[^\d.]/g, '')) * 100) : 0);
  }

  function setAvailability(ok) {
    available = ok;
    [$('hp-atc'), $('hp-sticky-atc')].forEach(function (b) {
      if (!b) return;
      b.disabled = !ok;
      var l = b.querySelector('.hp-atc-l');
      if (l) l.textContent = ok ? 'Add to basket' : 'Sold out';
    });
    var flag = $('hp-flag'), ft = $('hp-flag-t');
    if (flag) flag.classList.toggle('is-oos', !ok);
    // while the kitchen is closed for a festival (the top bar's tkFest), say when it ships instead
    var fest = typeof window.tkFest === 'function' ? window.tkFest() : null;
    var shipT = fest && fest.phase === 'closed' ? 'ships ' + fest.ships : 'ships in 24h';
    if (ft) ft.textContent = ok ? 'In stock · ' + shipT : 'Out of stock';
    // "Notify me on WhatsApp" follows the selected pack (see the markup).
    var notify = $('hp-restock');
    if (notify) {
      notify.hidden = ok;
      if (!ok && vidInput && vidInput.value) {
        var pack = sel ? sel.getAttribute('data-title') : '';
        var name = TITLE.trim() + (pack && pack !== 'Default Title' ? ' (' + pack + ')' : '');
        notify.href = notify.href.split('?')[0] + '?v=' + encodeURIComponent(vidInput.value) + '&p=' + encodeURIComponent(name);
      }
    }
  }

  function renderPrice() {
    var price = selPrice();
    var n = sel ? (+sel.getAttribute('data-n') || 1) : 1;
    var compare = sel ? +sel.getAttribute('data-compare') : 0;
    if ($('hp-price')) $('hp-price').textContent = rs(price);
    if ($('hp-per')) $('hp-per').textContent = '₹' + Math.round(price / 100 / (n * SERVES)) + ' per serving';
    if ($('hp-mrp')) {
      $('hp-mrp').hidden = !(compare > price);
      if ($('hp-compare')) $('hp-compare').textContent = rs(compare);
    }
    if (sel) {
      if ($('hp-pack-name')) $('hp-pack-name').textContent = sel.getAttribute('data-title');
      if ($('hp-serves')) $('hp-serves').textContent = 'Serves ' + (n * SERVES);
    }
    if ($('hp-sticky-p')) $('hp-sticky-p').textContent = rs(price * qty);
    if ($('hp-sticky-s')) $('hp-sticky-s').textContent = (sel ? sel.getAttribute('data-title') : '') + (qty > 1 ? ' × ' + qty : '') + ' · ' + TITLE;
    renderShip();
    renderFbtTotal();
  }

  function renderBatch() {
    var el = $('hp-batch'), lead = $('hp-batch-lead');
    if (!el || !lead || !sel) return;
    var max = parseInt(el.getAttribute('data-max'), 10) || 0;
    var n = parseInt(sel.getAttribute('data-stock'), 10);
    var low = !isNaN(n) && n > 0 && n <= max;
    lead.textContent = low ? ('Only ' + n + ' left of this pack.') : 'Cooked in small batches.';
  }

  function choose(p, focus) {
    if (!p || p === sel) return;
    packs.forEach(function (o) {
      var on = o === p;
      o.setAttribute('aria-checked', String(on));
      o.tabIndex = on ? 0 : -1;
    });
    sel = p;
    if (vidInput) vidInput.value = p.getAttribute('data-id');
    if (focus) p.focus();
    renderPrice();
    renderBatch();
    setAvailability(p.getAttribute('data-available') !== 'false');
    try {
      var u = new URL(location.href);
      u.searchParams.set('variant', p.getAttribute('data-id'));
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  }
  packs.forEach(function (p, i) {
    p.addEventListener('click', function () { choose(p); });
    p.addEventListener('keydown', function (e) {
      var k = e.key, j = -1;
      if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % packs.length;
      else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + packs.length) % packs.length;
      else if (k === 'Home') j = 0;
      else if (k === 'End') j = packs.length - 1;
      if (j > -1) { e.preventDefault(); choose(packs[j], true); }
    });
  });
  if (sel) setAvailability(sel.getAttribute('data-available') !== 'false');

  /* ---------- quantity ---------- */
  $$('[data-hp-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      qty = Math.max(1, Math.min(20, qty + (+b.getAttribute('data-hp-qty'))));
      if (qtyInput) qtyInput.value = qty;
      if ($('hp-qty')) $('hp-qty').textContent = qty;
      renderPrice();
    });
  });

  /* ---------- add to basket ---------- */
  function add(btn) {
    if (!available || !vidInput) return;
    var vid = vidInput.value;
    if (typeof window.addToCart === 'function') { window.addToCart(vid, qty, btn); return; }
    var f = $('hp-form'); if (f) f.submit();
  }
  var form = $('hp-form');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add($('hp-atc')); });
  if ($('hp-sticky-atc')) $('hp-sticky-atc').addEventListener('click', function () { add($('hp-sticky-atc')); });

  /* ---------- free delivery progress (mirrors the cart drawer) ---------- */
  var cartSub = typeof window.tkCartSubtotal === 'number' ? window.tkCartSubtotal : 0;
  function renderShip() {
    var wrap = $('hp-ship'), t = $('hp-ship-t'), fill = $('hp-ship-fill');
    if (!wrap) return;
    var total = cartSub > 0 ? cartSub : selPrice() * qty / 100;
    wrap.hidden = false;
    // The Diwali stock-up (theme.js TK_BULK_*): past free delivery the line follows the drawer's steps,
    // the free Pav Bhaji at ₹1,200, then ₹300 off at ₹3,500, under the limited-time pill.
    var bulk = typeof window.tkBulkName === 'function' ? window.tkBulkName() : '';
    if (typeof window.tkBulkPill === 'function') window.tkBulkPill($('hp-offer'), total, true);
    // Past free delivery the line follows the drawer's ladder: the free Pav Bhaji at ₹1,200, the wrapped
    // surprise dish at ₹2,000 (theme.js TK_SUR_*), then, in the festival, ₹300 off at ₹3,500.
    if (total >= THRESHOLD && typeof window.tkSurOn === 'function') {
      var GIFT = window.TK_GIFT_THRESHOLD || 1200, SUR = window.TK_SUR_THRESHOLD || 2000, BULK = window.TK_BULK_THRESHOLD || 3500, OFF = window.TK_BULK_OFF || 300;
      var surOn = window.tkSurOn(), S3 = surOn ? SUR : GIFT;
      var gw = typeof window.tkFestName === 'function' && window.tkFestName() ? 'our ' + window.tkFestName() + ' gift: a free Pav Bhaji' : 'a free Pav Bhaji';
      var rs = function (n) { return '₹' + Math.ceil(n).toLocaleString('en-IN'); };
      var set = function (h, f) { if (t) t.innerHTML = h; if (fill) fill.style.setProperty('--hp-p', Math.min(1, Math.max(0.05, f)).toFixed(3)); };
      var got = 'Free delivery, a free Pav Bhaji' + (surOn ? ' and a surprise dish' : '');
      if (total < GIFT) set('Free delivery unlocked. Add <b>' + rs(GIFT - total) + '</b> for ' + gw + '.', total / GIFT);
      else if (surOn && total < SUR) set('Free delivery and Pav Bhaji unlocked. Add <b>' + rs(SUR - total) + '</b> to unwrap a surprise dish.', (total - GIFT) / (SUR - GIFT));
      else if (bulk && total < BULK) set((surOn ? 'Pav Bhaji and a surprise dish unlocked.' : 'Free delivery and Pav Bhaji unlocked.') + ' Add <b>' + rs(BULK - total) + '</b> to save ₹' + OFF + '.', (total - S3) / (BULK - S3));
      else if (bulk) set('<b>₹' + OFF + ' ' + bulk + ' saving unlocked</b>, with ' + got.charAt(0).toLowerCase() + got.slice(1) + '.', 1);
      else set('<b>' + got + ' unlocked</b> on this order.', 1);
      return;
    }
    if (total >= THRESHOLD) {
      if (t) t.innerHTML = '<b>Free delivery unlocked</b> on this order.';
      if (fill) fill.style.setProperty('--hp-p', 1);
    } else {
      if (t) t.innerHTML = 'Add <b>₹' + Math.ceil(THRESHOLD - total) + '</b> more for free delivery';
      if (fill) fill.style.setProperty('--hp-p', Math.max(0.05, total / THRESHOLD).toFixed(3));
    }
  }
  if (!cartSub) {
    fetch('/cart.js').then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }).then(function (cart) {
      cartSub = typeof window.tkComputeFoodSubtotal === 'function' ? window.tkComputeFoodSubtotal(cart) : (cart.items_subtotal_price || 0) / 100;
      renderShip();
    }).catch(function () {});
  }
  window.addEventListener('cart:subtotal', function () { cartSub = window.tkCartSubtotal || 0; renderShip(); });
  // theme.js (the offer's helpers) runs after this file: paint again once it has
  window.addEventListener('load', renderShip);

  /* ---------- pincode: 3 days to Gujarat's cities, 4 to 5 elsewhere (theme.js tkDeliveryFor) ---------- */
  var pinForm = $('hp-pin-form');
  if (pinForm) pinForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var out = $('hp-pin-out'), v = ($('hp-pin-in').value || '').replace(/\D/g, '');
    if (v.length !== 6 || v[0] === '0') { out.textContent = 'Enter a valid 6-digit pincode.'; return; }
    var d = typeof window.tkDeliveryFor === 'function' ? window.tkDeliveryFor(v) : null;
    out.textContent = d ? d.text : 'Delivers to ' + v + ' in 3 to 5 days.';
    // a festival break (the top bar's tkFest): the date to order by for this pincode, or, while
    // the kitchen is closed, when it ships instead of the 24-hour line
    var fn = d && typeof window.tkFestPin === 'function' ? window.tkFestPin(window.tkFestLocal ? window.tkFestLocal(v) : d.area, d.city || v) : '';
    if (fn && window.tkFest().phase === 'closed') out.textContent = fn;
    else if (fn) { var fb = document.createElement('b'); fb.className = 'hp-pin-fest'; fb.textContent = fn; out.appendChild(document.createTextNode(' ')); out.appendChild(fb); }
    try { localStorage.setItem('tk-pin', v); } catch (x) {}
    showStores(v);
  });
  // Also on the shelves: if the pincode is in a city with stores (the Stores page's list, theme.js
  // tkLoadStores / tkStoresFor), say so under the delivery line, with the stores and the way to them.
  // The list is fetched once per visit, as soon as the pincode box is touched.
  var pinStore = $('hp-pin-store'), pinIn = $('hp-pin-in');
  function showStores(v) {
    if (!pinStore || typeof window.tkLoadStores !== 'function') return;
    pinStore.hidden = true;
    window.tkLoadStores().then(function (list) {
      if (($('hp-pin-in').value || '').replace(/\D/g, '') !== v) return;
      var hit = window.tkStoresFor(v, list);
      if (!hit) return;
      var st = hit.stores, n = st.length, html;
      if (n === 1) {
        html = '<b>Also on the shelves in ' + esc(hit.city) + '</b><span>' + esc(st[0].n) + (st[0].a ? ', ' + esc(st[0].a.split(/\n/)[0]) : '') + ' stocks Thakar Kitchen. Dishes vary by store, so call ahead for ' + esc(TITLE) + '.</span>'
          + '<span class="hp-pin-links"><a href="' + esc(st[0].m) + '" target="_blank" rel="noopener">Directions</a>' + (st[0].p ? '<a href="tel:' + esc(st[0].p.replace(/\s/g, '')) + '">Call ' + esc(st[0].p) + '</a>' : '') + '</span>';
      } else {
        var names = st.slice(0, 2).map(function (x) { return esc(x.n); }).join(n > 2 ? ', ' : ' and ');
        html = '<b>Also on the shelves in ' + esc(hit.city) + '</b><span>' + names + (n > 2 ? ' and ' + (n - 2) + ' more ' + (n - 2 === 1 ? 'store' : 'stores') : '') + ' stock Thakar Kitchen. Dishes vary by store, so call ahead for ' + esc(TITLE) + '.</span>'
          + '<span class="hp-pin-links"><a href="/pages/stores#city-' + esc(hit.slug) + '">See the ' + n + ' stores and directions</a></span>';
      }
      pinStore.innerHTML = '<svg class="hp-ico" aria-hidden="true"><use href="#hp-i-pin"/></svg><div>' + html + '</div>';
      pinStore.hidden = false;
    });
  }
  if (pinIn) {
    pinIn.addEventListener('focus', function () { if (typeof window.tkLoadStores === 'function') window.tkLoadStores(); }, { once: true });
    try { var lastPin = localStorage.getItem('tk-pin'); if (lastPin && !pinIn.value) pinIn.value = lastPin; } catch (x) {}
  }

  /* ---------- share ---------- */
  $$('[data-hp-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (typeof window.tkShareUrl === 'function') { window.tkShareUrl(location.href, TITLE); return; }
      if (navigator.share) { navigator.share({ title: TITLE, url: location.href }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).catch(function () {});
    });
  });

  /* ---------- FAQ deep links ---------- */
  function openFaq(i) { var d = $('faq-' + i); if (d) d.open = true; }
  $$('[data-hp-faq]').forEach(function (a) { a.addEventListener('click', function () { openFaq(a.getAttribute('data-hp-faq')); }); });
  var hm = /^#faq-(\d+)$/.exec(location.hash); if (hm) openFaq(hm[1]);
  window.addEventListener('hashchange', function () { var m = /^#faq-(\d+)$/.exec(location.hash); if (m) openFaq(m[1]); });

  /* ---------- reviews: more ---------- */
  var moreBtn = $('hp-more-rev');
  if (moreBtn) moreBtn.addEventListener('click', function () {
    var open = moreBtn.getAttribute('aria-expanded') !== 'true';
    $$('[data-hp-more]').forEach(function (q) { q.hidden = !open; });
    moreBtn.setAttribute('aria-expanded', String(open));
    moreBtn.textContent = open ? 'Show fewer reviews' : 'Read more reviews';
  });

  /* ---------- how to heat tabs ---------- */
  var tabs = $$('[data-hp-method]');
  function setMethod(tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      var panel = $(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
    if ($('hp-f-total')) $('hp-f-total').textContent = tab.getAttribute('data-total');
    if ($('hp-f-hands')) $('hp-f-hands').textContent = tab.getAttribute('data-hands');
    if ($('hp-f-need')) $('hp-f-need').textContent = tab.getAttribute('data-need');
    if ($('hp-tip')) $('hp-tip').textContent = tab.getAttribute('data-tip');
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { setMethod(t); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); setMethod(tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true); }
    });
  });

  /* ---------- inside the pouch: the pouch's layers in the dish's own shades (bottom up: grains, vegetables, dairy and oils, spices, finishing) ---------- */
  (function () {
    var src = $('hp-ings'), bar = $('hp-bar'), list = $('hp-groups'), spec = $('hp-spec');
    if (!src || !bar || !list) return;
    var data; try { data = JSON.parse(src.textContent); } catch (e) { return; }
    if (!data || !data.length) return;
    var cs = getComputedStyle(root);
    // each group in the colour of what it is, from the house palette: dal yellow, vegetable green,
    // ghee brass, chilli red, water blue (the same on every dish, so a shopper learns it once)
    function tok(n, d) { return (cs.getPropertyValue(n) || '').trim() || d; }
    var FAMCOL = { base: tok('--hp-turmeric', '#D9A032'), veg: tok('--hp-leaf', '#5E7D3A'), rich: tok('--hp-gold', '#B4904E'), spice: tok('--hp-sindoor', '#B8412F'), finish: tok('--hp-peacock-lt', '#5FC0B8') };
    var FAMS = [
      { id: 'base', label: 'Lentils, grains & flours', cats: ['grain'] },
      { id: 'veg', label: 'Vegetables & herbs', cats: ['vegetable', 'herb'] },
      { id: 'rich', label: 'Dairy, oils & nuts', cats: ['dairy', 'oil', 'nut'] },
      { id: 'spice', label: 'Spices & salt', cats: ['spice', 'salt'] },
      { id: 'finish', label: 'Finishing notes & water', cats: ['sweet', 'water'] }
    ];
    var catBase = { vegetable: 5.0, grain: 4.2, oil: 3.4, dairy: 2.6, nut: 1.8, sweet: 1.4, spice: 1.0, herb: 0.9, salt: 0.6, water: 0.5 };
    var fam = {};
    FAMS.forEach(function (f) { fam[f.id] = { f: f, w: 0, items: [] }; });
    data.forEach(function (d) {
      var m = /(\d+(?:\.\d+)?)\s*%/.exec(d.i);
      var w = m ? Math.pow(parseFloat(m[1]), 0.96) : (catBase[d.c] || 1);
      var f = FAMS.filter(function (x) { return x.cats.indexOf(d.c) > -1; })[0] || FAMS[3];
      fam[f.id].w += w;
      fam[f.id].items.push(d.i);
    });
    var active = FAMS.filter(function (f) { return fam[f.id].items.length; });
    var total = active.reduce(function (a, f) { return a + fam[f.id].w; }, 0);
    // what each group really is (for the spoken label), then drawn at least 8% tall so a small group is
    // still visible and tappable in the pouch's curved bottom
    var rawTotal = total;
    active.forEach(function (f) { fam[f.id].raw = fam[f.id].w; fam[f.id].w = Math.max(fam[f.id].w, total * 0.08); });
    total = active.reduce(function (a, f) { return a + fam[f.id].w; }, 0);
    var focus = -1;
    function setFocus(i) {
      focus = focus === i ? -1 : i;
      spec.classList.toggle('is-focus', focus > -1);
      $$('button', bar).forEach(function (b, k) { b.classList.toggle('is-on', k === focus); b.setAttribute('aria-pressed', String(k === focus)); });
      $$('li', list).forEach(function (l, k) { l.classList.toggle('is-on', k === focus); });
    }
    bar.innerHTML = active.map(function (f, i) {
      var pct = Math.max(1, Math.round(fam[f.id].raw / rawTotal * 100));
      return '<button type="button" aria-pressed="false" data-share="' + (fam[f.id].w / total).toFixed(4) + '" style="flex-basis:' + (fam[f.id].w / total * 100).toFixed(2) + '%;background:' + FAMCOL[f.id] + '" aria-label="' + esc(f.label) + ', about ' + pct + '% of the pouch"></button>';
    }).join('');
    list.innerHTML = active.map(function (f, i) {
      return '<li><i style="background:' + FAMCOL[f.id] + '"></i><span><b>' + esc(f.label) + '</b><span>' + esc(fam[f.id].items.join(', ')) + '</span></span></li>';
    }).join('');
    $$('button', bar).forEach(function (b, i) { b.addEventListener('click', function () { setFocus(i); }); });
    $$('li', list).forEach(function (l, i) { l.addEventListener('click', function () { setFocus(i); }); });
    bar.hidden = false; list.hidden = false;
    if ($('hp-pouch')) $('hp-pouch').hidden = false;
    if ($('hp-plainlist')) $('hp-plainlist').hidden = true;
    if ($('hp-spec-hint')) $('hp-spec-hint').hidden = false;
  })();

  /* ---------- quick add on recommendation cards ---------- */
  $$('[data-hp-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = +b.getAttribute('data-hp-add');
      if (typeof window.recoQuickAdd === 'function') window.recoQuickAdd(id, b);
      else if (typeof window.addToCart === 'function') window.addToCart(id, 1, b);
    });
  });

  /* ---------- complete your thali (bundle) ---------- */
  var fbtItems = [];
  function renderFbtTotal() {
    var n = $('hp-fbt-n'), sum = $('hp-fbt-sum'), btn = $('hp-fbt-add');
    if (!n || !fbtItems.length) return;
    var boxes = $$('#hp-fbt-list input[type=checkbox]');
    var count = 1, tot = selPrice();
    boxes.forEach(function (c, i) { if (c.checked) { count++; tot += fbtItems[i].price; } });
    var thisPr = $('hp-fbt-this'); if (thisPr) thisPr.textContent = rs(selPrice());
    n.textContent = count + (count === 1 ? ' item' : ' items');
    sum.textContent = rs(tot);
    btn.textContent = count === 1 ? 'Add to basket' : (count === 2 ? 'Add both to basket' : 'Add all ' + count + ' to basket');
  }
  (function () {
    var box = $('hp-fbt'), ul = $('hp-fbt-list');
    if (!box || !ul) return;
    var tiles = {}; try { tiles = JSON.parse(($('hp-tiles') || {}).textContent || '{}'); } catch (e) {}
    function start() {
      if (typeof window.tkFetchRecsPool !== 'function') return false;
      window.tkFetchRecsPool().then(function (pool) {
        if (!pool || !pool.length) return;
        var cuisine = root.getAttribute('data-cuisine');
        function tagStr(p) { var t = p.tags || []; return (Array.isArray(t) ? t.join(' ') : String(t)).toLowerCase(); }
        function isRice(p) { return /rice|pulav|biryani/.test(p.handle) || tagStr(p).indexOf('rice dishes') > -1; }
        function cuisineOf(p) { var t = tagStr(p); return (t.indexOf('north-indian') > -1 || t.indexOf('north indian') > -1) ? 'north-indian' : 'gujarati'; }
        function buyable(p) {
          if (typeof window.tkBuyableVariant === 'function') return window.tkBuyableVariant(p);
          var v = p.variants && p.variants[0]; return v && v.available !== false ? v : null;
        }
        function rating(p) { return typeof window.tkGetRating === 'function' ? (window.tkGetRating(p.handle)[0] || 0) : 0; }
        var cands = pool.filter(function (p) { return p.handle !== HANDLE && buyable(p); });
        cands.sort(function (a, b) { return rating(b) - rating(a); });
        var pick = [];
        var selfRice = /rice|pulav|biryani/.test(HANDLE);
        if (!selfRice) {
          var rice = cands.filter(isRice);
          var jeera = rice.filter(function (p) { return p.handle === 'jeera-rice'; })[0] || rice[0];
          if (jeera) pick.push(jeera);
        }
        cands.filter(function (p) { return !isRice(p) && cuisineOf(p) === cuisine && pick.indexOf(p) < 0; }).slice(0, 2 - pick.length).forEach(function (p) { pick.push(p); });
        cands.filter(function (p) { return pick.indexOf(p) < 0 && !isRice(p); }).slice(0, 2 - pick.length).forEach(function (p) { pick.push(p); });
        if (!pick.length) return;
        fbtItems = pick.map(function (p) {
          var v = buyable(p);
          var vid = typeof v === 'object' && v ? v.id : v;
          var price = Math.round(parseFloat((typeof v === 'object' && v && v.price) || (p.variants[0] && p.variants[0].price) || 0) * 100);
          var raw = (p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : '';
          var img = raw ? raw.replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, '_200x200$1$2') : '';
          var name = typeof window.tkCleanTitle === 'function' ? window.tkCleanTitle(p.title) : p.title;
          return { id: vid, price: price, img: img, name: name, handle: p.handle, weight: (window.tkWeightMap && window.tkWeightMap[p.handle]) || '' };
        }).filter(function (x) { return x.id && x.price; });
        if (!fbtItems.length) return;
        var selfImg = slides[0] ? slides[0].querySelector('img') : null;
        var html = '<li><label><span class="hp-fix" aria-hidden="true"><svg class="hp-ico"><use href="#hp-i-check"/></svg></span><span class="hp-th"' + '>' + (selfImg ? '<img src="' + esc(selfImg.currentSrc || selfImg.src) + '" alt="">' : '') + '</span><span class="hp-nm"><b>' + esc(TITLE) + '</b><small class="is-this">This dish</small></span><span class="hp-pr" id="hp-fbt-this">' + rs(selPrice()) + '</span></label></li>';
        html += fbtItems.map(function (it, i) {
          return '<li><label><input type="checkbox" checked aria-label="Add ' + esc(it.name) + '"><span class="hp-th" style="--hp-c:' + esc(tiles[it.handle] || '') + '">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') + '</span><span class="hp-nm"><b><a href="/products/' + esc(it.handle) + '" style="text-decoration:none">' + esc(it.name) + '</a></b><small>' + esc(it.weight) + '</small></span><span class="hp-pr">' + rs(it.price) + '</span></label></li>';
        }).join('');
        ul.innerHTML = html;
        $$('input[type=checkbox]', ul).forEach(function (c) { c.addEventListener('change', renderFbtTotal); });
        box.hidden = false;
        renderFbtTotal();
      }).catch(function () {});
      return true;
    }
    var fbtBtn = $('hp-fbt-add');
    if (fbtBtn) fbtBtn.addEventListener('click', function () {
      if (!vidInput) return;
      var ids = [];
      if (available) ids.push(+vidInput.value);
      $$('#hp-fbt-list input[type=checkbox]').forEach(function (c, i) { if (c.checked) ids.push(+fbtItems[i].id); });
      if (!ids.length) return;
      if (typeof window.addToCart === 'function') {
        ids.forEach(function (id, i) { window.addToCart(id, 1, i === ids.length - 1 ? fbtBtn : null); });
      } else {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }) });
      }
    });
    if (!start()) window.addEventListener('load', start);
  })();

  /* ---------- sticky add to basket ---------- */
  var sticky = $('hp-sticky'), anchor = $('hp-atc-anchor');
  var mq = window.matchMedia('(max-width: 899px)');
  // desktop: on once the main button has scrolled away above the screen. An IntersectionObserver
  // tells us, so nothing measures the page on every scroll frame (that forced a layout per frame).
  var anchorAbove = false;
  function stickyCheck() {
    if (!sticky) return;
    var on = mq.matches || anchorAbove;
    if (sticky.classList.contains('is-on') === !!on && sticky.getAttribute('aria-hidden') === String(!on)) return;
    sticky.classList.toggle('is-on', !!on);
    sticky.setAttribute('aria-hidden', String(!on));
    var b = $('hp-sticky-atc'); if (b) b.tabIndex = on ? 0 : -1;
  }
  if (anchor && 'IntersectionObserver' in window) new IntersectionObserver(function (e) { anchorAbove = !e[0].isIntersecting && e[0].boundingClientRect.bottom < 0; stickyCheck(); }).observe(anchor);
  else if (anchor) window.addEventListener('scroll', function () { anchorAbove = anchor.getBoundingClientRect().bottom < 0; stickyCheck(); }, { passive: true });
  window.addEventListener('resize', stickyCheck);
  if (mq.addEventListener) mq.addEventListener('change', stickyCheck);

  renderPrice();
  renderBatch();
  stickyCheck();
})();

/* ---------- never in the pouch: tap to cross out ----------
   The four chips arrive crossed out (the meaning never waits on a tap). Here they are cleared, and each
   tap draws a marigold pen stroke and says why that thing is not in the pouch; all four crossed out
   says so. With motion allowed, the first one crosses itself out once as it comes into view, to show
   the chips can be tapped. A tap never forces a layout: classes and text only. */
(function () {
  var box = document.getElementById('hp-free');
  if (!box) return;
  var chips = [].slice.call(box.querySelectorAll('.hp-free-c'));
  var why = document.getElementById('hp-free-why');
  var hint = box.querySelector('.hp-free-hint');
  if (!chips.length || !why) return;
  var touched = false;
  chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
  box.classList.add('is-live');
  if (hint) hint.hidden = false;
  function say(html) {
    why.classList.remove('is-new');
    why.innerHTML = html;
    requestAnimationFrame(function () { why.classList.add('is-new'); });
  }
  function strike(c) {
    c.setAttribute('aria-pressed', 'true');
    var left = chips.filter(function (x) { return x.getAttribute('aria-pressed') !== 'true'; }).length;
    var name = c.querySelector('.hp-free-w').textContent.trim();
    if (left === 0 && touched) {
      say('<b>None of the four.</b> Not in this pouch, not in any of ours.');
      if (hint) hint.hidden = true;
    } else {
      say('<b>' + name + ':</b> ' + c.getAttribute('data-why'));
    }
  }
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      touched = true;
      if (hint) hint.hidden = true;
      strike(c);
    });
  });
  var motion = window.tkMotion ? window.tkMotion() : !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (motion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (e) {
      if (!e[0].isIntersecting) return;
      io.disconnect();
      setTimeout(function () { if (!touched && chips[0].getAttribute('aria-pressed') !== 'true') strike(chips[0]); }, 600);
    }, { threshold: 0.8 });
    io.observe(box);
  }
})();

/* ---------- motion: small signs of life as the page scrolls ----------
   Everything here is optional polish: it only starts when motion is allowed and
   IntersectionObserver exists, it never touches the first screen (so nothing the
   shopper lands on waits for an animation), and the markup is complete without it. */
(function () {
  var root = document.getElementById('hp');
  if (!root || !('IntersectionObserver' in window)) return;
  if (window.tkMotion ? !window.tkMotion() : window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var top = root.querySelector('.hp-top');
  var foldY = window.innerHeight;
  function belowFold(el) { return el.getBoundingClientRect().top > foldY * 0.9 && !(top && top.contains(el)); }
  function stagger(kids) { kids.forEach(function (k, i) { k.style.setProperty('--i', Math.min(i, 6)); }); }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.classList.add('is-in');
      if (e.target._hpIn) e.target._hpIn();
    });
  }, { rootMargin: '0px 0px 12% 0px', threshold: 0 });   // starts just before it reaches the screen, so nothing is still appearing when you arrive

  // section heads: ornament, then eyebrow, heading and lede
  root.querySelectorAll('.hh .hp-head').forEach(function (h) {
    if (!belowFold(h)) return;
    stagger([].slice.call(h.children));
    h.classList.add('hp-rv'); io.observe(h);
  });
  // groups whose children follow one after another
  var groups = ['.hp-quotes', '.hp-table', '.hp-stamp', '#hp-groups', '.hp-rail', '.hp-faqs', '.hp-steps'];
  groups.forEach(function (sel) {
    root.querySelectorAll(sel).forEach(function (g) {
      if (!belowFold(g)) return;
      var kids = [].slice.call(g.children).filter(function (k) { return !k.hidden; });
      if (!kids.length) return;
      kids.forEach(function (k) { k.classList.add('hp-rv-i'); });
      stagger(kids);
      g.classList.add('hp-rv-g'); io.observe(g);
    });
  });

  // heritage: the years count up as the stamp lands (the markup already holds the real number)
  var stamp = root.querySelector('.hp-stamp.hp-rv-g');
  if (stamp) stamp._hpIn = function () {
    var s = [].slice.call(stamp.children).filter(function (k) { return /^\d+ years$/.test(k.textContent.trim()); })[0];
    if (!s) return;
    var n = parseInt(s.textContent, 10), t0 = 0;
    s.setAttribute('aria-label', n + ' years');
    (function tick(t) {
      t0 = t0 || t;
      var p = Math.min(1, (t - t0) / 1100), e = 1 - Math.pow(1 - p, 3);
      s.textContent = Math.round(n * e) + ' years';
      if (p < 1) requestAnimationFrame(tick);
    })(performance.now());
  };

  // the pouch fills: once its layers exist and it sits below the first screen, a paper cover hides them;
  // when the pouch is half in view the cover slides up group by group (bottom first), a wave rides its
  // edge, each group's dot in the list lands as its layer does, and the count in the heading ticks up
  var pouch = document.getElementById('hp-pouch'), cover = document.getElementById('hp-pouch-cover');
  function fillPouch() {
    var layers = [].slice.call(document.querySelectorAll('#hp-bar button'));
    var dots = [].slice.call(document.querySelectorAll('#hp-groups li'));
    var num = document.getElementById('hp-ing-n'), n = num ? parseInt(num.textContent, 10) || 0 : 0;
    var STEP = 620, lvl = 0;
    pouch.classList.add('is-pouring');
    layers.forEach(function (l, i) {
      lvl += parseFloat(l.getAttribute('data-share')) || 0;
      var to = i === layers.length - 1 ? 'calc(-100% - 12px)' : (-lvl * 100).toFixed(1) + '%';
      setTimeout(function () {
        cover.style.transform = 'translateY(' + to + ')';
        if (dots[i]) dots[i].classList.add('is-landed');
      }, 150 + i * STEP);
    });
    var total = 150 + layers.length * STEP;
    setTimeout(function () { pouch.classList.remove('is-pouring', 'is-empty'); cover.style.transform = ''; }, total + 400);
    if (num && n > 1) {
      var t0 = 0;
      requestAnimationFrame(function tick(t) {
        t0 = t0 || t;
        var p = Math.min(1, (t - t0) / total), v = Math.max(1, Math.round(n * (1 - Math.pow(1 - p, 2))));
        if (num.textContent !== String(v)) num.textContent = v;
        if (p < 1) requestAnimationFrame(tick);
      });
    }
  }
  function armPouch() {
    if (!pouch || !cover) return true;
    if (pouch.hidden || !document.querySelectorAll('#hp-bar button').length) return false;
    if (!belowFold(pouch) || pouch.classList.contains('is-empty')) return true;
    pouch.classList.add('is-empty');
    var pio = new IntersectionObserver(function (e) {
      if (!e[0].isIntersecting) return;
      pio.disconnect();
      fillPouch();
    }, { threshold: 0.5 });
    pio.observe(pouch);
    return true;
  }
  if (pouch && !armPouch()) new MutationObserver(function (m, obs) { if (armPouch()) obs.disconnect(); }).observe(pouch, { attributes: true, attributeFilter: ['hidden'] });

  // heat steps and the reading thread share one scroll handler, only while useful
  var sticky = document.getElementById('hp-sticky'), heat = document.getElementById('hp-heat'), heatOn = false, raf = 0;
  if (heat) new IntersectionObserver(function (e) { heatOn = e[0].isIntersecting; onScroll(); }).observe(heat);
  // the reading thread is a scroll-linked CSS animation where the browser has them (pdp.css), run
  // by the compositor; only older browsers get it from here
  var cssRead = window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
  function frame() {
    raf = 0;
    var vh = window.innerHeight;
    if (sticky && !cssRead) {
      var max = document.documentElement.scrollHeight - vh;
      sticky.style.setProperty('--hp-read', max > 0 ? Math.min(1, window.scrollY / max).toFixed(4) : 0);
    }
    if (heatOn) {
      var ol = heat.querySelector('.hp-steps:not([hidden])');
      if (!ol) return;
      var r = ol.getBoundingClientRect(), line = vh * 0.62;
      ol.style.setProperty('--hp-prog', Math.max(0, Math.min(1, (line - r.top - 30) / Math.max(1, r.height - 60))).toFixed(3));
      [].forEach.call(ol.children, function (li) { li.classList.toggle('is-lit', li.getBoundingClientRect().top + 26 < line); });
    }
  }
  function onScroll() { if (!raf && (heatOn || !cssRead)) raf = requestAnimationFrame(frame); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (heat) heat.addEventListener('click', function (e) { if (e.target.closest('[data-hp-method]')) setTimeout(onScroll, 0); });
  onScroll();

  // printing should show everything, animated or not
  window.addEventListener('beforeprint', function () { root.querySelectorAll('.hp-rv,.hp-rv-g,.hp-grow').forEach(function (el) { el.classList.add('is-in'); }); if (pouch) pouch.classList.remove('is-empty', 'is-pouring'); if (cover) cover.style.transform = ''; });
})();
